<div class="left">
  <div class="orders">
    @if (loading) { }@else if(orders.length==0){
    <nz-empty nzNotFoundContent="No Order"></nz-empty>
    }@else { @for (order of orders; track $index) {
    <app-user-order-list-item
      [data]="order"
      [ngClass]="{'active':order==activeOrder}"
      (click)="onOrderClick(order)"
    ></app-user-order-list-item>
    } } @if (total>0) {
    <mat-paginator
      [pageIndex]="page-1"
      [length]="total"
      [pageSize]="pageSize"
      (page)="onPageChanged($event)"
    ></mat-paginator>
    }
  </div>
</div>
<div class="right">
  @if (activeOrder) {
  <app-user-order-details-panel
    [order]="activeOrder"
  ></app-user-order-details-panel>
  }
</div>

<div class="expansions">
  @if (loading) { }@else if(orders.length===0){
  <nz-empty nzNotFoundContent="No Order"></nz-empty>
  }@else{
  <mat-accordion>
    @for (order of orders; track $index) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <app-price [price]="order.total"></app-price>
        </mat-panel-title>
        <mat-panel-description>
          {{order.created_at|date:'short'}}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <app-user-order-details-panel
        [order]="order"
      ></app-user-order-details-panel>
    </mat-expansion-panel>
    }
  </mat-accordion>
  } @if (total>0) {
  <mat-paginator
    [pageIndex]="page-1"
    [length]="total"
    [pageSize]="pageSize"
    (page)="onPageChanged($event)"
  ></mat-paginator>
  }
</div>
